/**
 * Host-scoped axios instance for NKognito Live. Uses a distinct
 * `host_session_token` in localStorage so host + player sessions
 * can coexist in the same browser without stepping on each other.
 */
import axios from "axios";

export const HOST_TOKEN_KEY = "host_session_token";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const hostApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

hostApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(HOST_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function getHostToken() {
  return localStorage.getItem(HOST_TOKEN_KEY);
}
export function setHostToken(token) {
  if (token) localStorage.setItem(HOST_TOKEN_KEY, token);
  else localStorage.removeItem(HOST_TOKEN_KEY);
}
